export default {
    test(state){
        return state.test + "getters的test数据" 
    }
}